<span class="p-2" placement="top" ngbTooltip="This field is disabled.">
  <small class="mx-2 text-muted">(Disabled)</small>
</span>
